import { render } from "./ViewMailTemplate.vue?vue&type=template&id=9ac1fc30&scoped=true"
import script from "./ViewMailTemplate.vue?vue&type=script&lang=js"
export * from "./ViewMailTemplate.vue?vue&type=script&lang=js"

import "./ViewMailTemplate.vue?vue&type=style&index=0&id=9ac1fc30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac1fc30"]])

export default __exports__